import { render, staticRenderFns } from "./PharmaceuticsComponent.vue?vue&type=template&id=b4d76a50&scoped=true&"
import script from "./PharmaceuticsComponent.vue?vue&type=script&lang=js&"
export * from "./PharmaceuticsComponent.vue?vue&type=script&lang=js&"
import style0 from "./PharmaceuticsComponent.vue?vue&type=style&index=0&id=b4d76a50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d76a50",
  null
  
)

export default component.exports